import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import { useTeamPublicStore } from '@/stores/teamPublic.js'

export default {
  mixins:[fetchDataMixin],
  props: {
    teamId: {
      type: Number,
      required: true
    }
  },
  computed: {
    team() {
      return useTeamPublicStore().getItemById(this.teamId)
    },
    layout() {
      return 'fundraiser-team-layout-modern'
    }
  },
  methods: {
    async fetchTeamPublic() {
      const team = await this.fetchData(useTeamPublicStore().fetchItemById, this.teamId)
      document.title = this.team.name + ' - ' + document.title
      return team
    }
  }
}
